<div class="row">
  <div class="col-sm-12 col-md-10 d-flex justify-content-end mx-auto">
    <div class="zoom-controls">
      <button class="button-control mx-2" mat-mini-fab matTooltip="Primary" color="primary" aria-label="Remove icon" (click)="zoomOut()">
        <mat-icon>remove</mat-icon>
      </button>
      <button class="button-control mx-2" mat-mini-fab matTooltip="Primary" color="primary" aria-label="Add icon" (click)="zoomIn()">
        <mat-icon>add</mat-icon>
      </button>
    </div>
  </div>
  <div class="col-12">
    <div #graphContainer class="graph-container mx-auto"></div>
  </div>
</div>

